import _ from "lodash";
import React from "react";
import TableRow from "../TableRow";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import {
  handleDragAndDrop,
  shouldNodeRender,
  shouldShowTagCheckbox,
} from "GenericTableEditor/GenericTableEditorUtils";

const TableRows = props => {
  const {
    nodes,
    setNodes,
    rootNodeId,
    mode,
    maxDepth,
    indexCountArray,
    droppableSnapshot,
    filterNodesIds,
    currentEditorConfig,
    filteredNodeIds,
    gradeOptions,
    tagOptions,
    createNewTags,
    filters,
    scrollBehaviourRef,
    setNodesRef,
    setSelectedSidebarNodes,
    taggedNodeIds,
    taggedNodesWithAncestors,
    taggedNodeIdsWithAncestors,
    onClickTagCheckbox,
    sortedNodeIds,
    tableContainerRef,
  } = props;

  const rootNode = nodes[rootNodeId];
  const hasChildren = !_.isEmpty(_.get(rootNode, "children", []));
  const isNotApexNode = rootNode && rootNode.depth !== 0;

  const shouldRowRender = shouldNodeRender({
    filteredNodeIds,
    rootNodeId,
  });

  const showTagCheckbox = shouldShowTagCheckbox({
    hasChildren,
    taggedNodesWithAncestors,
    taggedNodeIdsWithAncestors,
    nodeId: rootNodeId,
  });

  // push the node id in the sequenced array used for multiselect
  // if its not topmost node and is filtered and is a leaf node
  const pushInSortedIds = isNotApexNode && shouldRowRender && !hasChildren;
  if (pushInSortedIds) {
    sortedNodeIds.push(rootNodeId);
  }

  const isNodeTagged = _.includes(taggedNodeIds, rootNodeId);

  return (
    <>
      {isNotApexNode && shouldRowRender ? (
        <TableRow
          nodes={nodes}
          setNodes={setNodes}
          nodeId={rootNodeId}
          mode={mode}
          maxDepth={maxDepth}
          indexCountArray={indexCountArray}
          isDraggingOver={droppableSnapshot.isDraggingOver}
          draggingOverWith={droppableSnapshot.draggingOverWith}
          filterNodesIds={filterNodesIds}
          currentEditorConfig={currentEditorConfig}
          hasChildren={hasChildren}
          gradeOptions={gradeOptions}
          tagOptions={tagOptions}
          createNewTags={createNewTags}
          filters={filters}
          scrollBehaviourRef={scrollBehaviourRef}
          setNodesRef={setNodesRef}
          setSelectedSidebarNodes={setSelectedSidebarNodes}
          isNodeTagged={isNodeTagged}
          showTagCheckbox={showTagCheckbox}
          onClickTagCheckbox={onClickTagCheckbox}
          tableContainerRef={tableContainerRef}
        />
      ) : null}
      {hasChildren
        ? _.map(rootNode.children, childId => {
            return (
              <TableRows
                key={childId}
                nodes={nodes}
                setNodes={setNodes}
                rootNodeId={childId}
                mode={mode}
                maxDepth={maxDepth}
                indexCountArray={indexCountArray}
                droppableSnapshot={droppableSnapshot}
                filterNodesIds={filterNodesIds}
                currentEditorConfig={currentEditorConfig}
                filteredNodeIds={filteredNodeIds}
                gradeOptions={gradeOptions}
                tagOptions={tagOptions}
                createNewTags={createNewTags}
                filters={filters}
                scrollBehaviourRef={scrollBehaviourRef}
                setNodesRef={setNodesRef}
                setSelectedSidebarNodes={setSelectedSidebarNodes}
                taggedNodeIds={taggedNodeIds}
                taggedNodesWithAncestors={taggedNodesWithAncestors}
                taggedNodeIdsWithAncestors={taggedNodeIdsWithAncestors}
                onClickTagCheckbox={onClickTagCheckbox}
                sortedNodeIds={sortedNodeIds}
                tableContainerRef={tableContainerRef}
              />
            );
          })
        : null}
    </>
  );
};

const TableBody = props => {
  const indexCountArray = [];

  const { nodes, setNodes } = props;

  const handleOnDragEnd = result => {
    handleDragAndDrop({
      result,
      nodes,
      setNodes,
      indexCountArray,
    });
  };

  return (
    <DragDropContext onDragEnd={handleOnDragEnd}>
      <Droppable droppableId={"TABLE_BODY"}>
        {(provided, snapshot) => (
          <tbody ref={provided.innerRef} {...provided.droppableProps}>
            <TableRows
              {...props}
              indexCountArray={indexCountArray}
              droppableSnapshot={snapshot}
            />
          </tbody>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default TableBody;
